import React, {useRef, useEffect , useState } from 'react';
import '../css/ProductCarousel.css';

const products = [
  {
    id: 1,
    nombre: 'Chile Cabro',
    descripcion: 'Salsa espesa y tradicional, elaborada artesanalmente con chile cabro (habanero) nicaragüense.',
    presentacion: 'Botella de vidrio (150 ml)',
    Ingredientes:'Chile Cabro, Vinagre, Sal, Aceite de Oliva Extra Virgen, Benzoato de Sodio',
    picor: 'Extremo',
    // textura: 'Espesa y casera',
    // natural: 'Sin conservantes ni colorantes',
    //imagen: 'botellaHabanero250ml.jpeg'
   imagen: 'figurasbotellaHabanero250ml.jpeg'
  },
  {
    id: 2,
    nombre: 'Chile cola de Gallo',
    descripcion: 'Salsa de chile cola de gallo, bien picosa y con sabor casero que enchila sabroso.',
    presentacion: 'Botella de vidrio (150 ml)',
    Ingredientes:'Chile cola de Gallo, Vinagre, Sal, Aceite de Oliva extra virgen, Benzoato de Sodio.',
    picor: 'Medio - Alto',
    // textura: 'Espesa y casera',
    // natural: 'Hecha a mano sin aditivos',
    imagen: 'figurabotellaColaGallo250ml.jpeg'
  },
  {
    id: 3,
    nombre: 'Chile Jalapeño & Chimichurri',
    descripcion: 'Explosión de sabor que combina el toque picante del jalapeño con la frescura y los aromas intensos del chimichurri tradicional.',
    presentacion: 'Botella de vidrio (150 ml)',
    Ingredientes:'Chile Jalapeño, Perejil, Ajo, Sal,  Vinagre, Aceite de Oliva extra virgen, Benzoato de Sodio.',
    picor: 'Medio - Alto',
    // textura: 'Espesa y casera',
    // natural: 'Hecha a mano sin aditivos',
    imagen: 'figurabotellaJalapeno250ml.jpeg'
  },
  {
    id: 4,
    nombre: 'Chile Chipotle',
    descripcion: 'Salsa chipotle con el toque picoso y sabroso que no puede faltar en tus comidas.',
    presentacion: 'Botella de vidrio (150 ml)',
    Ingredientes:'Chile Chipotle, Vinagre, Sal, Agua, Benzoato de Sodio.',
    picor: 'Medio - Alto',
    // textura: 'Espesa y casera',
    // natural: 'Hecha a mano sin aditivos',
    imagen: 'figurabotellaChipotle250ml.jpeg'
  },
  {
    id: 5,
    nombre: 'Chileros de Cebolla',
    // descripcion: 'Salsa de chile cola de gallo, bien picosa y con sabor casero que enchila sabroso.',
    presentacion: 'Botella de vidrio (150 ml)',
    Ingredientes:'Chile cabro, cebolla, vinagre, agua, Sal',
    picor: 'Medio-alto',
    // textura: 'Espesa y casera',
    // natural: 'Hecha a mano sin aditivos',
    imagen: 'frascoCebolla150ml.jpg'
  },
  {
    id: 6,
    nombre: 'Pasta de Chimichurri',
    // descripcion: 'Salsa de chile cola de gallo, bien picosa y con sabor casero que enchila sabroso.',
    presentacion: 'Frasco 9 onza (266 ml) ',
    Ingredientes:'Perejil, ajo, vinagre, aceite oliva extra virgen, sal, aceite de soja, goma xantan',
    picor: 'Ninguno',
    // textura: 'Espesa y casera',
    // natural: 'Hecha a mano sin aditivos',
    imagen: 'frascoPastadeChimichurri.jpeg'
  },
];
//frascoPastadeChimichurri
function ProductCarousel() {
  const carouselRef = useRef(null);
  const intervalIdRef = useRef(null);
  const resumeTimeoutRef = useRef(null);

  const startAutoScroll = () => {
    const carousel = carouselRef.current;
    if (!carousel) return;
      
    // solo iniciar si hay overflow horizontal
    if (carousel.scrollWidth > carousel.clientWidth) {
      intervalIdRef.current = setInterval(() => {
        carousel.scrollBy({
          left: 300,
          behavior: 'smooth',
        });

        if (carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 10) {
          setTimeout(() => {
            carousel.scrollTo({ left: 0, behavior: 'smooth' });
          }, 1000);
        }
      }, 3000);
    }
  };
const stopAutoScroll = () => {
    clearInterval(intervalIdRef.current);
  };

  const pauseAndResume = () => {
    stopAutoScroll();
    clearTimeout(resumeTimeoutRef.current);
    resumeTimeoutRef.current = setTimeout(() => {
      startAutoScroll();
    }, 5000); // Reanuda después de 5 segundos de inactividad
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
    startAutoScroll();
  }, 500); // ⏳ medio segundo para que se alinee visualmente

  return () => {
    stopAutoScroll();
    clearTimeout(timeout);
  };
  }, []);

  const scroll = (direction) => {
    const scrollAmount = 300;
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
    pauseAndResume(); // también al hacer clic en botón manual
 
};
  return (
    <section className="product-section" id="productos" >
       <h2 className="section-title">Productos</h2>
      <div className="carousel-container center">
        <button className="nav-button left" onClick={() => scroll('left')}>←</button>
        <div
          className="product-carousel"
          ref={carouselRef}
          onTouchStart={pauseAndResume}
          onTouchEnd={pauseAndResume}
          onMouseEnter={pauseAndResume}
          onMouseLeave={pauseAndResume}
        >
        {/* <div className="product-carousel" ref={carouselRef}> */}
              {products.map(producto => (
        <div key={producto.id} className="product-card">
          <img
            src={require(`../img/${producto.imagen}`)}
            alt={producto.nombre}
            className="product-image"
          />
          <h3>{producto.nombre}</h3>
          <p>{producto.descripcion}</p>
          <ul>
             <li><strong>Ingredientes:</strong> {producto.Ingredientes}</li>
             <li><strong>Presentación:</strong> {producto.presentacion}</li>
             <li><strong>Picor:</strong> {producto.picor}</li>
           
            {/* <li><strong>Natural:</strong> {producto.natural}</li> */}
          </ul>
        </div>
      ))}
        </div>
        <button className="nav-button right" onClick={() => scroll('right')}>→</button>
      </div>
      <h2 className="section-title">Productos 100% Nicaragüense</h2>

      <div>
         <img
        src={require('../img/banner.jpeg')}
        alt="Banner principal"
        className="banner-image"
      />
      </div>


    </section>
  );
}

export default ProductCarousel;